import { Box, Link, Typography } from '@mui/material';
import React, { ReactElement } from 'react';
import { HeadTag } from 'shared/components';

const FinishUploadReworkPage = (): ReactElement => {
    /**
     * Handle onlick of logo in footer area
     */
    const handleLogoFooterOnClick = React.useCallback(() => {
        // navigation('/manage-cross-checks');
    }, []);
    return (
        <>
            <HeadTag title="Finish Upload Documents" />
            <Box
                className="finish-wrapper"
                alignItems="flex-start"
                justifyContent="space-between"
            >
                <Box
                    className="wrapper-text"
                    display="flex"
                    alignItems="center"
                    flexGrow="1"
                    width="100%"
                    justifyContent="center"
                    flexDirection="column"
                >
                    <Typography variant="h1">Good Job!</Typography>
                    <Typography>Document on this Cross check</Typography>
                    <Typography>is no longer missing</Typography>
                    <br />
                    <Typography>
                        If you require any further assistance,
                    </Typography>
                    <Typography>
                        please contact us at:{' '}
                        <Link href="mailto:support@doxai.co">
                            support@doxai.co
                        </Link>
                    </Typography>
                </Box>
                <Box className="menu-footer" p={14}>
                    <img
                        className="app-logo"
                        src="/images/brand/logo-uow-dark.png"
                        onClick={handleLogoFooterOnClick}
                        alt="UOW logo"
                        width={200}
                        height={188}
                    />
                </Box>
            </Box>
        </>
    );
};

export default FinishUploadReworkPage;
